<template>
    <b-form-group
            v-if="dataIsVisible"
            class="c-checkbox"
            :label-for="id"
            :label-cols="labelCols"
            :label="label"
            :aria-describedby="id + '_InvalidFeedback'">
        <template slot="description">
            <label v-html="description"></label>
        </template>

        <c-switch v-if="required" :state="chkState(id)" class="mx-1" color="success" v-model="dataValue" label v-bind="dataIcon" />
        <c-switch v-if="!required" class="mx-1" color="success" v-model="dataValue" label v-bind="dataIcon" />

        <b-form-invalid-feedback :id="id + '_InvalidFeedback'">
          {{invalidFeedbackMessage}}
        </b-form-invalid-feedback>
        <div v-if="required && !chkState(id)" style="display: block" class="invalid-feedback">
            <span v-if="invalidFeedbackMessage !== ''">{{invalidFeedbackMessage}}</span>
            <span v-if="invalidFeedbackMessage === ''">{{Core.Definition.getDefinition('Vous devez cocher la case.')}}</span>
        </div>
    </b-form-group>
</template>

<script>
    import { Switch as cSwitch } from '@coreui/vue'
  export default {
      name: 'InputCheckbox',
      components: {
          cSwitch
      },
      props: {
          icon: {
              type: Object,
              default: function() {
                  return {
                      dataOn: '\u2713',
                      dataOff: '\u2715'
                  }
              }
          },
          required: {
              type: Boolean,
              default: false
          },
          value: {
              type: Boolean | String | Number,
              default: false
          },
          id: {
              type: String,
              default: ''
          },
          label: {
              type: String,
              default: ''
          },
          placeholder: {
              type: String,
              default: ''
          },
          description: {
              type: String,
              default: ''
          },
          labelCols: {
              type: Number,
              default: 0
          },
          autocomplete: {
              type: String,
              default: ''
          },
          invalidFeedbackMessage: {
              type: String,
              default: ''
          },
          form: {
              type: Object,
              default: function() {return {}}
          },
          fieldRefs: {
              type: Array,
              default: function () {
                  return []
              }
          },
          _isVisible: {
              type: Boolean,
              default: true
          },
          onChange: {
              type: Function,
              default: function() {}
          },
      },
      watch: {
          value(val) {
              if (val == '0' || val == '' || val === 0) {
                  val = false
              }
              if (val == '1' || val === 1) {
                  val = true
              }
              this.dataValue = val
          },
          dataValue(val) {
              this.$emit('input', val)
              this.onChange( val, this.form.$model, this.fieldRefs)
          }
      },
      mounted() {
          this.dataIsVisible = this._isVisible
          let value =  Core.Value.encode(this.value, Core.Value.typeCheckbox)
          this.dataValue = value
          this.dataIcon = this.icon
      },
      data: () => {
          return {
              Core: window.Core,
              dataValue: '',
              dataIsVisible: true,
              dataIcon: {
                  dataOn: '\u2713',
                  dataOff: '\u2715'
              }
          }
      },
      computed: {
          isVisible: {
              set(val) {
                  this.dataIsVisible = val
              },
              get() {
                  return this.dataIsVisible
              }
          }
      },
      methods: {
          chkState(val) {
              if (this.form !== undefined && this.form[val] !== undefined) {
                  const field = this.form[val]
                  return !field.$dirty || !field.$invalid
              }
          }
      }
  }
</script>